import React, { useEffect, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { ClearRounded, EditRounded } from "@mui/icons-material";
import { API, endpoints } from "../../api/api";
import { Button } from "../../controls";
import { Alert, Dialog, Table } from "../../layout";
import { AddEditFollowUp } from "..";
import { useTranslation } from "react-i18next";

const InqFollowUps = ({ val }) => {
  const [followUps, setFollowUps] = useState([]);
  const [updData, setUpdData] = useState();
  const [showForm, setShowForm] = useState(false);
  const { t } = useTranslation();
  const [alert, setAlert] = useState({
    isOpen: false,
    type: "",
    title: "",
    subTitle: "",
  });

  useEffect(() => {
    val.followUps.length && setFollowUps([...val.followUps]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [val]);

  const handleAddEdit = (data) => {
    setUpdData(data);
    setShowForm(true);
  };

  const handleDlt = (id) => {
    setAlert({
      isOpen: true,
      type: "confirmation",
      title: t("cfmTitle"),
      subTitle: t("followUpDltTitle"),
      onConfirm: () => {
        const onComplete = (res) => {
          if (res && res.status === 200) {
            setAlert({
              isOpen: true,
              type: "success",
              title: t("dltSuccessTitle"),
              subTitle: res.msg,
            });
            setFollowUps((x) => [...x.filter((j) => j.id !== res.result.id)]);
          } else if (res) {
            setAlert({
              isOpen: true,
              type: "warning",
              title: "Warning",
              subTitle: res.msg,
            });
          }
        };
        API(endpoints.FollowUp).Delete(id, onComplete);
      },
    });
  };
  const ActionComp = (val) => (
    <div className="bs-secondary br-8 w-fit">
      <Tooltip title={t("Edit")}>
        <IconButton
          onClick={() => handleAddEdit(val)}
          size="small"
          color="primary"
          className="mr-5 p-5"
        >
          <EditRounded className="fs-18 m-2" />
        </IconButton>
      </Tooltip>
      <Tooltip title={t("Delete")}>
        <IconButton
          onClick={() => handleDlt(val.id)}
          size="small"
          color="error"
          className="mr-5 p-5"
        >
          <ClearRounded className="fs-18 m-2" />
        </IconButton>
      </Tooltip>
    </div>
  );

  const HeaderComp = () => (
    <div>
      <Button variant="text" onClick={() => handleAddEdit()}>
        {t("AddFollowUp")}
      </Button>
    </div>
  );

  return (
    <div>
      <Table
        ActionComp={ActionComp}
        HeaderComp={HeaderComp}
        tblHead={[
          { id: "followUpDate", label: t("FollowUpDate") },
          { id: "followUpTime", label: t("FollowUpTime") },
          { id: "type", label: t("Type") },
          { id: "note", label: t("Note") },
          { id: "actions", label: t("Actions") },
        ]}
        tblData={followUps.map((j) => ({
          ...j,
          type: j.followUpType && j.followUpType.name,
        }))}
      />

      {/* Add Follow Up */}
      {showForm && (
        <Dialog show={showForm} onClose={false} maxWidth="sm">
          <AddEditFollowUp
            {...{ setShowForm, setAlert, inqData: val, setFollowUps, updData }}
          />
        </Dialog>
      )}
      {/* Alert  */}
      <Alert alert={alert} setAlert={setAlert} />
    </div>
  );
};

export default InqFollowUps;
